import { temAcesso } from '@/shared/auth/temAcesso'

const avaliacoesDespesasGerais = () => import('./avaliacoesDespesasGerais/AvaliacoesDespesasGerais.vue')

export default {
    path: 'avaliacoesdespesasgerais',
    name: 'Avaliacoes_DespesasGerais',
    component: avaliacoesDespesasGerais,
    beforeEnter: (to, from, next) => {
        if (temAcesso('DESP-GERAIS-REL-00')) {
            next()
        }
    },
    children: []
}
